import { styled } from '@mui/styles';
import { theme } from '../../../../../../../theme';

const UploadCompaniesModalStyled = styled('div')(({ theme: { palette, spacing } }: any) => ({
    '& .paper': {
        backgroundColor: palette.background.paper,
        borderRadius: 14,
        padding: spacing(2.5, 0, 0),
        minWidth: '60vw',
        maxWidth: '60vw',
        '& .header': {
            position: 'relative',
            boxSizing: 'border-box',
            padding: spacing(0, 5),
            height: '80px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            '& .title': { fontSize: '19px', fontWeight: 500, color: palette.colors.black },
            '& .close-icon': {
                position: 'absolute',
                right: '33px',
                width: '45px',
                height: '45px',
                boxSizing: 'border-box',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: `0.8px solid ${palette.colors.greyInformationLight}`,
                borderRadius: '23px',
                '& svg': {
                    fontSize: '35px',
                    color: palette.colors.greyDark,
                },
            },
        },
        '& .content': {
            padding: spacing(3.3, 5),
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            overflowY: 'scroll',
            maxHeight: '60vh',
            minHeight: '20vh',
            fontSize: '15px',
            borderTop: `1px solid ${palette.colors.greyInformationLight}`,
            borderBottom: `1px solid ${palette.colors.greyInformationLight}`,
        },
        '& .footer': {
            padding: spacing(2.2, 5),
            justifyContent: 'space-between',
            alignItems: 'center',
            '& .bread-crumbs': {
                display: 'flex',
                marginRight: 'auto',
                '& .single': { padding: spacing(0, 0.5), color: palette.colors.greyDark },
                '& .completed': {
                    fontWeight: 500,
                    color: palette.subline,
                },
            },
            '& .match-counter': {
                '& .counter': { marginBottom: spacing(0.9), fontSize: '15px', color: palette.subline },
                '& .info': { fontSize: '13px', color: palette.colors.greyDark },
            },
            '& .action': {
                '& .action-button': {
                    maxWidth: '140px',
                    height: '48px',
                    backgroundColor: palette.primary.light,
                    color: palette.colors.white,
                    borderRadius: '25px',
                    '&:hover': {
                        backgroundColor: palette.primary.main,
                    },
                    '&.disabled': {
                        backgroundColor: palette.colors.greyInformationLight,
                        color: palette.colors.greyDark,
                        cursor: 'not-allowed',
                    },
                },
            },
        },
        '& .progress': {
            display: 'flex',
            height: '10px',
            overflow: 'hidden',
            fontSize: '.75rem',
            boxSizing: 'border-box',
            backgroundColor: palette.colors.informationGreyPale,
            borderBottomLeftRadius: '14px',
            borderBottomRightRadius: '14px',
        },
    },
    [theme.breakpoints.down('xl')]: {
        '& .paper': {
            '& .footer': {
                display: 'block',
                '& .bread-crumbs': {
                    marginBottom: spacing(1.5),
                    '& > div:first-child': { paddingLeft: '0px' },
                },
                '& .match-counter': { margin: spacing(0) },
                '& .action': {
                    textAlign: 'right',
                },
            },
        },
    },
    [theme.breakpoints.up('lg')]: {
        '& .paper': {
            '& .footer': {
                display: 'flex',
                '& .match-counter': { margin: spacing(0, 3) },
            },
        },
    },
}));

export default UploadCompaniesModalStyled;
